import React, {  useEffect, useState } from "react";
import { 
  Button,
  Box, Grid,
  Typography, Divider,
  TextField,
  // FormControl,
  // FormLabel,
  // Radio,
  // RadioGroup,
  // FormControlLabel,
  IconButton,
  Tooltip,
} from "@mui/material";
import { styled } from '@mui/system';
import Navbar from "../components/NavBar/Navbar";
import Footer from "../components/Shared/Footer";
import { useTheme } from '@mui/material/styles';
import MySvgIcons from '../components/Shared/paymentMethods';
import { useOrderContext } from "../hooks/useContext/useOrderContext";
import { Delete, Edit, Done } from "@mui/icons-material";
import SimpleAlert from '../components/Shared/Alert';
import { useAvailableItemConfigContext } from "../hooks/useContext/useAvailableItemConfigContext";
import useFetchOpenStatus from "../hooks/useFetchOpenStatus";
import ImageContainer from "../components/Shared/ImageContainerBox";
import { useTranslation } from "../hooks/useTranslation";


const GridContainerMain = styled(Grid)(() => ({
  minHeight: "100vh",
  padding: '50px 10px 0',
  paddingTop: '50px',
  paddingBottom: '50px',
  display: 'flex',
  justifyContent: 'center',
}));


const Cart = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [showAlert, setShowAlert] = useState(false);
  const [showUpdateAlert, setShowUpdateAlert] = useState(false);
  const [activeNotesIndex, setActiveNotesIndex] = useState(null);
  const { order, dispatch } = useOrderContext();
//const { order, paymentMethod, setPaymentMethod, dispatch } = useOrderContext();
  const { openStatus } = useAvailableItemConfigContext();
  // const [paymentType, setPaymentType] = useState(paymentMethod || 'online');


  useFetchOpenStatus();

  const translateSize = (size) => {
    if (size === 'Small') return t('small');
    if (size === 'Large') return t('large');
    if (size === 'One Size') return t('oneSize');
    return size;
  };

  const CustomDelete = styled(Delete)({
    color: theme.palette.common.error,
  });

  // const handlePaymentChange = (event) => {
  //   setPaymentType(event.target.value);
  //   console.log("Selected Payment Method:", event.target.value);
  //   // setPaymentMethod(event.target.value);
  // };

  const handleToggleNotes = (index) => {
    setActiveNotesIndex((prev) => (prev === index ? null : index));
  };

  const handleSpecialInstructionsChange = (index, value) => {
    const newOrder = [...order];
    newOrder[index] = {
      ...newOrder[index],
      specialInstructions: value,
    };
    dispatch({ type: 'UPDATE_ORDER_NOTES', payload: newOrder });
  };

  const updateItemQuantity = (index, type) => {
    const newOrder = [...order];
    if (type === 'increment') {
      newOrder[index].itemQuantity += 1;
    } else if (type === 'decrement' && newOrder[index].itemQuantity > 1) {
      newOrder[index].itemQuantity -= 1;
    }
    dispatch({ type: 'UPDATE_ORDER_QUANTITY', payload: newOrder });
    setShowUpdateAlert(true);
    setTimeout(() => setShowUpdateAlert(false), 1400)
  };

  const handleSaveNotes = (index) => {
    // maybe reuse your newOrder logic here if you're not already saving onChange
    setShowUpdateAlert(true);
    setTimeout(() => setShowUpdateAlert(false), 1400);
  };

  const removeItemFromCart = (itemId, itemSize) => {
    dispatch({ type: 'REMOVE_ORDER', payload: { _id: itemId, itemSize: itemSize } });
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 1400)
  };

  //scroll to top is cart empty
  useEffect(() => {
    if (order.length === 0) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [order.length]);

  return (
    <div style={{ backgroundColor: theme.palette.common.background }}>

      <Navbar />
      {openStatus === false && <SimpleAlert text={t('storeClosed')} showAlert={!openStatus} type={'error'} />}
      {showAlert && <SimpleAlert text={t('successfullyDeletedItem')} showAlert={showAlert} type={"success"} />}
      {showUpdateAlert && <SimpleAlert text={t('successfullyUpdatedItem')} showAlert={showUpdateAlert} type={"success"} />}
      <GridContainerMain container spacing={0}>
      {order.length > 0 ? (
        <>
        <Grid container spacing={2} justifyContent="center">
        <Grid item xs={12} sm={12} md={8} lg={4.5} xl={3.5}>
            <Box sx={{ padding: 2, border: '1px solid #ccc', marginBottom: 2, backgroundColor: theme.palette.component.componentBackground }}>
                <Typography variant="body2" component="p" sx={{ textAlign: 'left' }} >
                    <b>{t('myCart')}</b>
                </Typography>
            </Box>
            {order.map((cartItem, index) => (
            <Box key={index} sx={{ padding: 2, border: '1px solid #ccc', marginBottom: 2, backgroundColor: theme.palette.component.componentBackground }}>
              <div key={index}> 
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <ImageContainer sx={{ paddingRight: "20px" }} itemName={cartItem.itemName} itemImage={cartItem.itemImage} />
                  </Grid>
                  <Grid item xs={8}>
                    <Grid container direction="column" spacing={0} sx={{ paddingTop: "20px" }}>

                      <Grid item sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>
                            <Typography variant="p" sx={{ textAlign: "left" }}>
                            {`${cartItem.itemPrice} ${t('currency')}`}
                            </Typography>
                        </span>
                        <span>
                        <IconButton
                          sx={{ "&:hover": { backgroundColor: "#f2eeef" } }}
                          size="large"
                          aria-label={t('removeItem')}
                          aria-haspopup="true"
                          variant="outlined"
                          onClick={() => removeItemFromCart(cartItem._id, cartItem.itemSize)}
                        >
                          <Tooltip title={t('removeItem')} placement="top">
                            <CustomDelete />
                          </Tooltip>
                        </IconButton>
                        </span>
                      </Grid>
                      <Grid item>
                        <Typography variant="body2" gutterBottom sx={{ textAlign: "left" }}>
                          {cartItem.itemName}
                        </Typography>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid item xs={4}>
                          <Typography variant="body2" gutterBottom sx={{ textAlign: "left" }}>
                            {translateSize(cartItem.itemSize)}
                          </Typography>
                        </Grid>
                        <Grid item xs={8}>
                          <Typography variant="body2" gutterBottom sx={{ textAlign: "left" }}>
                            {t('qty')}: {cartItem.itemQuantity}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid item sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px', width: '100%' }}>
                          <span>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                              <Button onClick={() => updateItemQuantity(index, 'decrement')} variant="outlined">-</Button>
                              <Typography variant="subtitle1">{cartItem.itemQuantity}</Typography>
                              <Button onClick={() => updateItemQuantity(index, 'increment')} variant="outlined">+</Button>
                            </Box>
                          </span>
                          <span>
                            <Typography variant="p" sx={{ textAlign: 'right' }}>
                              {`${cartItem.itemQuantity * cartItem.itemPrice} ${t('currency')}`}
                            </Typography>
                          </span>
                        </Box>
                      </Grid>

                    </Grid>
                  </Grid>
                </Grid>

                {/* Customize item — only for food, optional */}
                {cartItem.itemType === 'Food' && (
                  <Box sx={{ mt: 1 }}>
                    <Grid container spacing={1} sx={{ marginTop: '10px' }}>
                      <Grid item sx={{ display: 'flex', flexDirection: 'column', width: '15%' }}>
                        <Typography
                          variant="body3"
                          sx={{
                            textDecoration: 'underline',
                            cursor: 'pointer',
                            color: theme.palette.common.grey,
                            textAlign: 'left',
                          }}
                          onClick={() => handleToggleNotes(index)}
                        >
                          {activeNotesIndex === index ?
                            <span>
                              <IconButton
                                sx={{ "&:hover": { backgroundColor: "#f2eeef" } }}
                                size="large"
                                aria-label={t('saveNotes')}
                                aria-haspopup="true"
                                variant="outlined"
                                onClick={() => handleSaveNotes(index)}
                              >
                                <Tooltip title={t('saveNotes')} placement="top">
                                  <Done sx={{ "&:hover": { color: theme.palette.common.blue } }} />
                                </Tooltip>
                              </IconButton>
                            </span>
                          :
                            <span>
                              <IconButton
                                sx={{ "&:hover": { backgroundColor: "#f2eeef" } }}
                                size="large"
                                aria-label={t('editNotes')}
                                aria-haspopup="true"
                                variant="outlined"
                                
                              >
                                <Tooltip title={t('editNotes')} placement="top">
                                  <Edit sx={{ "&:hover": { color: theme.palette.common.blue } }} />
                                </Tooltip>
                              </IconButton>
                            </span>
                          }
                        </Typography>
                      </Grid>
                      <Grid item sx={{ width: '85%' }}>
                        {cartItem.specialInstructions && activeNotesIndex !== index && (
                          <Typography
                            variant="body3"
                            sx={{
                              textAlign: "left",
                              mt: 0.5,
                              fontStyle: "italic",
                              color: theme.palette.common.grey,
                              whiteSpace: "pre-wrap",
                            }}
                          >
                            {cartItem.specialInstructions}
                          </Typography>
                        )}

                        {activeNotesIndex === index && (
                          <Box sx={{ mt: 1 }}>
                            <TextField
                              variant="standard"
                              fullWidth
                              multiline
                              minRows={2}
                              placeholder={t('specialInstructionsPlaceholder')}
                              value={cartItem.specialInstructions || ""}
                              onChange={(e) =>
                                handleSpecialInstructionsChange(index, e.target.value)
                              }
                            />
                          </Box>
                        )}
                      </Grid>
                    </Grid>
                  </Box>
                )}

              </div>
            </Box>
            ))}

            <Box sx={{ padding: 2, border: '1px solid #ccc', marginBottom: 2, backgroundColor: theme.palette.component.componentBackground }}>
              <Typography variant="body2" component="p" sx={{ textAlign: 'right' }} >
                <b>{t('subtotal')}</b>
                <span style={{ marginLeft: '15px' }}>
                  {`${order.reduce((acc, item) => acc + item.itemQuantity * item.itemPrice, 0)} ${t('currency')}`}
                </span>
              </Typography>
            </Box>

        </Grid>

        {/* Right Column: Total and Checkout button */}
        <Grid item xs={12} sm={12} md={4} lg={3.5} xl={2.5}>
            <Box sx={{
                position: 'sticky',
                top: '80px',
                height: '45vh',
                minHeight: '400px',
                padding: 2,
                border: '1px solid #ccc',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                backgroundColor: theme.palette.component.componentBackground,
            }}>
                {/* <FormControl sx={{ padding: "15px 15px" }}>
                    <FormLabel>Payment Method</FormLabel>
                    <RadioGroup
                        value={paymentType}
                        onChange={handlePaymentChange}
                    >
                    <FormControlLabel value="inPerson" control={<Radio />} label="Pay in Person" />
                    <FormControlLabel value="online" control={<Radio />} label="Online" />
                    </RadioGroup>
                </FormControl> */}

                {/* <Divider variant="middle" /> */}
                <Typography variant="body1" component="p" sx={{ textAlign: 'left', padding: "10px 15px" }} >
                  <b>{t('summary')}</b>
                </Typography>
                <Divider variant="middle" />
                <Typography variant="body2" component="p" sx={{ textAlign: 'left', padding: "10px 15px" }} >
                  <b>{t('total')}</b>
                </Typography>
                <Divider variant="middle" />
                <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: "5px 15px" }}>
                    <Typography variant="body2" component="p">
                        <b>{t('subtotal')}</b>
                    </Typography>
                    <Typography variant="p" component="p">
                      {`${order.reduce((acc, item) => acc + item.itemQuantity * item.itemPrice, 0)} ${t('currency')}`}
                    </Typography>
                </Box>

                <Divider variant="middle" />
                <Button href="/checkout" variant="contained" color="primary" size="large" sx={{ padding: "10px", marginTop: "20px" }}>
                  {t('checkout')}
                </Button>
                <Box sx={{ display: 'flex', flexDirection: 'column', paddingTop: "20px", alignItems: 'center' }}>
                    {/* <Typography variant="body2" component="p" sx={{ padding: "10px 10px" }} >
                        <b>We Accept:</b>
                    </Typography> */}
                    <MySvgIcons sx={{ width: '100%', height: 'auto' }}/>
                </Box>
            </Box>
        </Grid>
        </Grid>
        </>
        ) : (
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            padding: 2,
            border: `1px solid ${theme.palette.component.borderColor}`,
            marginBottom: 2,
            backgroundColor: theme.palette.component.componentBackground,
            width: '80%',
            maxWidth: '600px',
            height: '270px',
            borderRadius: '10px',
            textAlign: 'center',
            boxSizing: 'border-box',
            elevation: 1,
          }}>
            <Typography variant="h4" align='center' sx={{ textAlign: 'center', padding: "20px 0 50px 0" }}>
              {t('cartEmpty')}
            </Typography>
            <Button href="/order" variant="primaryButton" align='center'>
              {t('viewMenu')}
            </Button>
          </Box>
        )}
      </GridContainerMain>
      <Footer />
    </div>
  );
};

export default Cart;